/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function IconButton(theme: Theme): any {
  return {
    MuiIconButton: {
      variants: [
        { props: { color: "default" }, style: { "&:hover": { backgroundColor: theme.palette.action.hover } } },
        { props: { color: "inherit" }, style: { "&:hover": { backgroundColor: theme.palette.action.hover } } },
      ],

      styleOverrides: { root: {} },
    },
  };
}
